<script>
import { authComputed } from "@/store/helpers";
import BlotFormatter from "quill-blot-formatter";
import { ref } from "vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { mapActions } from "vuex";

export default {
  computed: {
    ...authComputed,
  },
  name: "AddParagraph",
  components: { QuillEditor },

  data() {
    return {
      paragraphTitle: "",
      paragraphText: "",
    };
  },

  inject: ["GStore"],

  setup: () => {
    const modules = {
      name: "blotFormatter",
      module: BlotFormatter,
      options: {
        /* options */
      },
    };

    const content = ref("");
    const { getParagraphs } = mapActions(["getParagraphs"]);

    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${store.state.user.token}`,
    //     "Content-Type": "application/json", // Added Content-Type header
    //   },
    // };
    // const setParagraphs = async () => {
    //   console.log("setParagraphs", content);
    //   return axios
    //     .post(
    //       store.state.api + "/api/v1/admin/addParagraph",
    //       content.value,
    //       config
    //     )
    //     .then(({ data }) => {
    //       console.log("Response data:", data);
    //     })
    //     .catch((error) => {
    //       console.error("Error:", error);
    //     });
    // };
    //
    // onMounted(() => {
    //   getParagraphs(); // Call the async function when the component is mounted
    // });

    return { modules, getParagraphs, content };
  },

  methods: {
    ...mapActions(["getParagraphs"]),

    resetForm() {
      this.paragraphTitle = "";
      this.paragraphText = "";
      if (this.$refs.quillRef) {
        console.log("Quill instance:", this.$refs.quillRef);
        const quillInstance = this.$refs.quillRef;
        if (quillInstance) {
          quillInstance.setText(""); // Set the content to an empty string
        }
      }
    },

    setParagraph() {
      this.$store
        .dispatch("addParagraph", {
          paragraphTitle: this.paragraphTitle,
          paragraphText: this.paragraphText,
        })
        .then(() => {
          this.resetForm();
          this.GStore.flashMessage =
            "A new paragraph was added ";
          setTimeout(() => {
            this.GStore.flashMessage = "";
          }, 3000);
        })
        .catch(() => {
          this.GStore.flashMessage =
            "An unknown error occurred. Please try again later! ";
          setTimeout(() => {
            this.GStore.flashMessage = "";
          }, 3000);
        });
    },
  },
};
</script>

<template>
  <div class="row">
    <h1 class="vrm-page-title">New paragraph</h1>
    <br />
    <form @submit.prevent="setParagraph">
      <fieldset class="fieldset">
        <div class="fieldset__item">
          <input placeholder="Paragraph title *" v-model="paragraphTitle" name="paragraphTitle" class="sg-element"
            type="text" value />
        </div>
      </fieldset>
      <QuillEditor ref="quillRef" class="sg-required" v-model:content="paragraphText" content-type="html"
        toolbar="#my-toolbar">
        <template #toolbar>
          <div id="my-toolbar">
            <select class="ql-size">
              <option value="small"></option>
              <option selected></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>

            <select class="ql-header">
              <option :value="1"></option>
              <option :value="2"></option>
              <option :value="3"></option>
              <option :value="4"></option>
              <option :value="5"></option>
              <option :value="6"></option>
            </select>
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
            <button class="ql-script" value="sub"></button>
            <button class="ql-script" value="super"></button>
            <select class="ql-align">
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
            </select>
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <button class="ql-blockquote"></button>
            <button class="ql-link"></button>
          </div>
        </template>
      </QuillEditor>

      <div class="vrm-panel--form__button-container" v-if="this.paragraphText.length > 15 && this.paragraphTitle">
        <button class="sg-btn sg-blue sg-element" type="submit" name="buttonAddParagraph">
          Submit
        </button>
        <div class="flashMessage" v-if="GStore.flashMessage">
          {{ GStore.flashMessage }}
        </div>
      </div>
    </form>
  </div>
</template>

<style scoped lang="less"></style>
